"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSearchResultsStore;

var _useLazyState = _interopRequireDefault(require("../hooks/useLazyState"));

/**
 * Allows for using search results.
 * @param lazyProps
 * @return {*[]}
 */
function useSearchResultsStore(lazyProps) {
  var additionalData = {
    reloading: false,
    pageData: Object.freeze({
      page: 0,
      filters: [],
      sort: 'rating',
      sortSaved: 'rating',
      sortOptions: [],
      filtersChanged: false
    })
  };
  return (0, _useLazyState["default"])(lazyProps, additionalData);
}
